export default {
    // C
    conversations: 'Conversations',

    // E
    error_title: 'Something went wrong',

    // F
    full: {
        title: 'This room is full',
        body: "Whoops, it looks like you tried to join a room with no open seats. MarketScale recording rooms can have up to {limit} participants, and every seat in this one is taken.",
        body_titled: "Whoops, it looks like you tried to join \"{title}\", which has no open seats. MarketScale recording rooms can have up to {limit} participants, and every seat in this one is taken.",
        in_room: 'In this room ({count} of {limit})',
        in_room_label: 'People in this room',
        next_step: "If you're trying to record, start a new room of your own. If you were expecting to join this one, ask the host to free up a seat for you.",
        start_new: 'Start a new recording',
        back_home: 'Back to Home',
    },
}
